import { Navigate, useParams } from 'react-router-dom';

import { ModuleSidebar } from '../components/ui/ModuleSidebar';
import { ProductNavigation } from '../components/ui/ProductNavigation';
import { findModuleMenuItem, findProductModule } from '../components/ui/ProductNavigation/navigation-data';
import styles from './ModulePlaceholderPage.module.css';

function decodeMenuLabel(value: string | undefined): string {
  try {
    return value ? decodeURIComponent(value) : '';
  } catch {
    return '';
  }
}

export function ModulePlaceholderPage() {
  const { moduleId, menuLabel } = useParams();
  const module = findProductModule(moduleId);
  const activeItem = module ? findModuleMenuItem(module, decodeMenuLabel(menuLabel)) : undefined;

  if (!module || !activeItem) return <Navigate replace to="/" />;

  return (
    <main className={styles.page}>
      <ProductNavigation defaultActive={module.label} />
      <div className={styles.workspace}>
        <ModuleSidebar activeItem={activeItem.label} ariaLabel={`${module.label}导航`} groups={module.groups} />
        <section aria-label={`${module.label} / ${activeItem.label}`} className={styles.emptyContent}>
          <h1 className={styles.visuallyHidden}>{activeItem.label}</h1>
        </section>
      </div>
    </main>
  );
}
